module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link-button"
  }, [_c('div', {
    staticClass: "link-button-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "link-button-top",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-796da32c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkButton.vue
// module id = 152
// module chunks = 2